__turbopack_context__.v({
  "avatarWrapper": "rZP0AG_avatarWrapper",
  "name": "rZP0AG_name",
  "userInfo": "rZP0AG_userInfo",
  "username": "rZP0AG_username",
  "wrapper": "rZP0AG_wrapper",
});
